// Aviso do navegador quando uma notificação do ResizeObserver fica para o
// próximo quadro. Não quebra nada para o cliente; vem de dentro do antd
// (AutoComplete, Upload, Modal medindo a si mesmos durante a animação).
// O Chrome antigo dizia "loop limit exceeded"; o atual, "loop completed with
// undelivered notifications".
export const IGNORED_ERRORS: (string | RegExp)[] = [
  /ResizeObserver loop limit exceeded/,
  /ResizeObserver loop completed with undelivered notifications/,
];

const PRODUCTION_HOSTS = ['cliente.contlabs.com.br'];
const DEVELOPMENT_HOSTS = ['localhost', '127.0.0.1'];

// Sem REACT_APP_ENV (é o caso do build de produção no Netlify), o ambiente
// sai do domínio; antes caía sempre em "development".
export const getSentryEnvironment = (hostname: string, configured?: string): string => {
  if (configured) return configured;
  if (PRODUCTION_HOSTS.indexOf(hostname) !== -1) return 'production';
  if (DEVELOPMENT_HOSTS.indexOf(hostname) !== -1) return 'development';
  return 'preview';
};
